/* ========================================================================
   COLDAYS PRODUCT PAGE - FULL FINAL JAVASCRIPT
   Handles: Slider, Variant Pricing, Vertical Tabs, Size Chart & Conversion
   ======================================================================== */

document.addEventListener('DOMContentLoaded', () => {
  const section = document.querySelector('[data-section-type="product"]');
  if (!section) return;

  // 1. READ MORE / READ LESS
  function initReadMore(container) {
    if (!container) return;
    const btn = container.querySelector('.cd-read-more-btn');
    const dots = container.querySelector('.cd-desc-dots');
    const longText = container.querySelector('.cd-desc-long');
    if (!btn || !dots || !longText) return;
    btn.addEventListener('click', () => {
      if (longText.style.display === 'none') {
        longText.style.display = 'inline';
        dots.style.display = 'none';
        btn.textContent = 'Read Less';
      } else {
        longText.style.display = 'none';
        dots.style.display = 'inline';
        btn.textContent = 'Read More';
      }
    });
  }
  section.querySelectorAll('[data-read-more-container]').forEach(initReadMore);

  // 2. VERTICAL TABS
  function initVerticalTabs(tabContainer) {
    if (!tabContainer) return;
    const btns = tabContainer.querySelectorAll('[data-v-tab]');
    const panels = tabContainer.querySelectorAll('[data-v-panel]');
    btns.forEach(btn => {
      btn.addEventListener('click', () => {
        btns.forEach(b => b.classList.remove('is-active'));
        panels.forEach(p => p.classList.remove('is-active'));
        btn.classList.add('is-active');
        const targetPanel = tabContainer.querySelector(`[data-v-panel="${btn.dataset.vTab}"]`);
        if (targetPanel) targetPanel.classList.add('is-active');
      });
    });
  }
  section.querySelectorAll('[data-vertical-tabs]').forEach(initVerticalTabs);

  // 3. VARIANT SELECTION, PRICING & URL UPDATE
  const variantSelect = section.querySelector('[data-variant-select]');
  const formVariantInput = section.querySelector('[data-form-variant-id]');

  function updateVariantImage(variantImageUrl) {
    if (!variantImageUrl) return;
    const desktopImg = section.querySelector('[data-variant-image]');
    const mobileImg = section.querySelector('[data-variant-image-mobile]');
    if (desktopImg) desktopImg.src = variantImageUrl;
    if (mobileImg) mobileImg.src = variantImageUrl;
  }

  function updatePrice(price, comparePrice) {
    // FIX: Added 'en-IN' locale string to properly format commas (e.g., 15,000.00)
    const formatMoney = (val) => {
      const formattedNumber = (val / 100).toLocaleString('en-IN', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
      return 'Rs. ' + formattedNumber;
    };
    
    const dPrice = section.querySelector('[data-price]');
    const dCompare = section.querySelector('[data-compare-price]');
    const dSalePct = section.querySelector('[data-sale-badge]');
    const dSaleLbl = section.querySelector('[data-sale-label]');
    const mPrice = section.querySelector('[data-price-mob]');
    const mCompare = section.querySelector('[data-compare-price-mob]');
    const mSalePct = section.querySelector('[data-sale-pct-mob]');

    if (dPrice) dPrice.textContent = formatMoney(price);
    if (mPrice) mPrice.textContent = formatMoney(price);

    if (comparePrice && comparePrice > price) {
      const discount = Math.round(((comparePrice - price) / comparePrice) * 100) + '%';
      if (dCompare) { dCompare.textContent = formatMoney(comparePrice); dCompare.style.display = ''; }
      if (mCompare) { mCompare.textContent = formatMoney(comparePrice); mCompare.style.display = ''; }
      if (dSalePct) { dSalePct.textContent = '-' + discount; dSalePct.style.display = ''; }
      if (mSalePct) { mSalePct.textContent = '-' + discount; mSalePct.style.display = ''; }
      if (dSaleLbl) dSaleLbl.style.display = '';
    } else {
      if (dCompare) dCompare.style.display = 'none';
      if (mCompare) mCompare.style.display = 'none';
      if (dSalePct) dSalePct.style.display = 'none';
      if (mSalePct) mSalePct.style.display = 'none';
      if (dSaleLbl) dSaleLbl.style.display = 'none';
    }
  }

  section.querySelectorAll('.coldays-product__size-btn, .coldays-product__mobile-size-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      section.querySelectorAll('.coldays-product__size-btn, .coldays-product__mobile-size-btn').forEach(b => b.classList.remove('is-active'));
      
      const val = btn.dataset.value.trim();
      section.querySelectorAll(`.coldays-product__size-btn[data-value="${val}"], .coldays-product__mobile-size-btn[data-value="${val}"]`).forEach(b => b.classList.add('is-active'));
      
      if (variantSelect) {
        const option = Array.from(variantSelect.options).find(opt => {
          const titles = opt.text.split('/').map(t => t.trim());
          return titles.includes(val) || opt.text.trim() === val;
        });

        if (option) {
          variantSelect.value = option.value;
          if (formVariantInput) formVariantInput.value = option.value;
          
          // FIX: Update ALL hidden inputs for Variant ID (including Fastrr/Shiprocket "Buy Now" forms)
          document.querySelectorAll('input[name="id"]').forEach(input => {
            input.value = option.value;
          });

          updateVariantImage(option.dataset.image);
          updatePrice(parseInt(option.dataset.price), parseInt(option.dataset.comparePrice) || 0);

          if (window.history.replaceState) {
            const newUrl = new URL(window.location.href);
            newUrl.searchParams.set('variant', option.value);
            window.history.replaceState({ path: newUrl.toString() }, '', newUrl.toString());
          }
        }
      }
    });
  });

  // 4. SIZE CHART MODAL & CONVERTER
  const sizeModal = section.querySelector('[data-size-chart]');
  if (sizeModal) {
    document.body.appendChild(sizeModal);
    const triggers = section.querySelectorAll('[data-size-chart-trigger], [data-size-chart-trigger-mobile]');
    const closeBtns = sizeModal.querySelectorAll('[data-size-chart-close], .coldays-size-chart__overlay');

    triggers.forEach(t => t.addEventListener('click', () => {
      sizeModal.classList.add('is-open');
    }));

    closeBtns.forEach(btn => btn.addEventListener('click', () => {
      sizeModal.classList.remove('is-open');
    }));

    const table = sizeModal.querySelector('[data-size-table]');
    const unitToggles = sizeModal.querySelectorAll('[data-unit-toggle] span');
    const fitLabel = sizeModal.querySelector('[data-fit-label]');

    if (table) {
      const customFit = table.getAttribute('data-fit');
      if (customFit && fitLabel) fitLabel.textContent = 'FIT: ' + customFit.toUpperCase();
      
      const cells = table.querySelectorAll('tbody td');
      cells.forEach(cell => {
        const val = parseFloat(cell.textContent);
        if (!isNaN(val)) cell.setAttribute('data-in-val', val);
      });

      unitToggles.forEach(toggle => {
        toggle.addEventListener('click', (e) => {
          if (e.target.classList.contains('is-active')) return;
          unitToggles.forEach(t => t.classList.remove('is-active'));
          e.target.classList.add('is-active');
          const unit = e.target.getAttribute('data-unit');
          cells.forEach(cell => {
            const inVal = cell.getAttribute('data-in-val');
            if (inVal) {
              if (unit === 'cm') {
                let cmVal = (parseFloat(inVal) * 2.54).toFixed(1);
                cell.textContent = cmVal.endsWith('.0') ? cmVal.slice(0, -2) : cmVal;
              } else {
                cell.textContent = inVal;
              }
            }
          });
        });
      });
    }
  }

  // 5. MOBILE IMAGE SLIDER
  const slider = section.querySelector('[data-mobile-slider]');
  const currIndicator = section.querySelector('[data-slider-current]');
  if (slider && window.innerWidth < 1024) {
    let startX = 0, currentIdx = 0;
    const slides = slider.children.length;

    slider.addEventListener('touchstart', e => { startX = e.touches[0].clientX; }, {passive: true});
    slider.addEventListener('touchend', e => {
      const diff = e.changedTouches[0].clientX - startX;
      if (Math.abs(diff) > 50) {
        if (diff < 0 && currentIdx < slides - 1) currentIdx++;
        else if (diff > 0 && currentIdx > 0) currentIdx--;
        
        slider.style.transform = `translateX(-${currentIdx * 100}%)`;
        if (currIndicator) currIndicator.textContent = currentIdx + 1;
      }
    });
  }

  // 6. MOBILE STICKY ATC HIDE LOGIC
  const stickyAtc = section.querySelector('[data-sticky-atc]');
  const mobileVideo = section.querySelector('[data-mobile-video-section]');

  if (stickyAtc && mobileVideo && window.innerWidth < 1024) {
    window.addEventListener('scroll', () => {
      const rect = mobileVideo.getBoundingClientRect();
      if (rect.top <= window.innerHeight) {
        stickyAtc.style.transform = 'translateY(100%)';
      } else {
        stickyAtc.style.transform = 'translateY(0)';
      }
    });
  }

  // 7. ADD TO CART / BUY NOW
  const productForm = section.querySelector('[data-product-form]');
  function addToCart(isBuyNow = false) {
    if (!productForm) return;
    if (isBuyNow) {
      let checkoutInput = productForm.querySelector('input[name="return_to"]');
      if (!checkoutInput) {
        checkoutInput = document.createElement('input');
        checkoutInput.type = 'hidden';
        checkoutInput.name = 'return_to';
        checkoutInput.value = '/checkout';
        productForm.appendChild(checkoutInput);
      }
      productForm.submit();
    } else {
      productForm.querySelector('.product-form__submit').click();
    }
  }
  section.querySelectorAll('[data-add-to-cart], [data-mobile-add-to-cart]').forEach(b => b.addEventListener('click', () => addToCart(false)));
  section.querySelectorAll('[data-buy-now], [data-mobile-buy-now]').forEach(b => b.addEventListener('click', () => addToCart(true)));

  // 8. LAZY VIDEO OBSERVER
  if ('IntersectionObserver' in window) {
    const videos = section.querySelectorAll('.coldays-product__scroll-video');
    const videoObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        const video = entry.target;
        if (entry.isIntersecting) {
          video.play().catch(() => {});
        } else {
          video.pause();
        }
      });
    }, { threshold: 0.3 });

    videos.forEach(video => videoObserver.observe(video));
  }
});